/**
 * Day (fleet) Alarms explore page — every boat that has a dataset on the selected date.
 * Columns: Datetime | Category | Source | Description.
 *
 * Named `Alarms.tsx`, not `FleetAlarms.tsx`: Sidebar's DAY_EXPLORE_FLEET_ALIAS only rewrites
 * map/overlay/video/timeseries/scatter/probability, so `alarms` falls straight through to the
 * file_path the database supplies.
 */
import AlarmsReportSection from "../../../../components/reports/AlarmsReportSection";

export default function DayAlarmsPage(props: Record<string, unknown>) {
  return <AlarmsReportSection {...props} variant="fleet" />;
}
